import { useRef } from 'react';

export const useUid = () => {
	const rowIndex = useRef(0);

	const get = (): number => {
		rowIndex.current += 1;
		return rowIndex.current;
	};

	return [get] as const;
};
